import { POSClient as Client } from "./client.js";

export * from "./constants/index.js";
export * from "./types/index.js";

export const POSClient = Client;
export default Client;
